import apiUsers from '../../api/apiUsers'

const state = {
    users: [],
    totalUsers: null,
    currentPage: null,
    lastPage: null,
    firstPage: 1,
    query: {
        page: 1,
        search: null
    }

}

const getters = {
    getUsers: (state) => {
        return state.users
    },
    getFirstUsersPage: (state) => {
        return state.firstPage
    },
    getCurrentUsersPage: (state) => {
        return state.currentPage
    },
    getLastUsersPage: (state) => {
        return state.lastPage
    },
    isLastUsersPage: (state) => {
        return state.currentPage === state.lastPage
    },
    getUsersQuerySearch: (state) => {
        return state.query.search
    },
    getUsersQuery: (state) => {
        return state.query
    },
    getTotalUsers: (state) => {
        return state.totalUsers
    }

}

const mutations = {
    setUsers: (state, newUsers) => {
        state.users = newUsers
    },
    setCurrentUsersPage: (state, pageNumber) => {
        state.currentPage = pageNumber
        state.query.page = pageNumber
    },
    setTotalUser: (state, totalUsers) => {
        state.totalUsers = totalUsers
    },
    setLastUsersPage: (state, pageNumber) => {
        state.lastPage = pageNumber
    },
    updateUsers: (state, newUsers) => {
        state.users = state.users.concat(newUsers)
    },
    updateUsersQuerySearch: (state, newValue) => {
        state.query.search = newValue
    },
    setDefaultUsersQuery: (state) => {
        const defaultQ = {
            page: 1,
            search: null
        }
        state.query = Object.assign({}, defaultQ)
    }
}

const actions = {
    fetchUsers: ({ commit, dispatch }) => {
        dispatch('setStatusLoading')
        apiUsers
            .userListRequest()
            .then((response) => {
                commit('setUsers', response.data.data)
                commit('setCurrentUsersPage', response.data.current_page)
                commit('setTotalUser', response.data.total)
                commit('setLastUsersPage', response.data.last_page)
                dispatch('setStatusLoaded')
            })
    },
    // alternative way { commit, dispatch, getters } <- gets only these methods from context variable
    loadMoreUsers: (context) => {
        context.commit('setCurrentUsersPage', (context.getters.getCurrentUsersPage + 1))
        apiUsers
            .userListRequest(context.getters.getUsersQuery)
            .then((response) => {
                context.commit('updateUsers', response.data.data)
            })
            .catch(error => console.log(error))
    },
    loadMoreUsersPagination: ({ commit, getters, dispatch }, page) => {
        dispatch('setStatusLoading')
        commit('setCurrentUsersPage', page)
        apiUsers
            .userListRequest(getters.getUsersQuery)
            .then((response) => {
                commit('setUsers', response.data.data)
                commit('setCurrentUsersPage', response.data.current_page)
                commit('setTotalUser', response.data.total)
                commit('setLastUsersPage', response.data.last_page)
                dispatch('setStatusLoaded')
            })
            .catch(error => console.log(error))
    },
    clearUsersQuery: ({ commit }) => {
        commit('setDefaultUsersQuery')
    },
    fetchUsersWithSearchQuery: (context) => {
        context.dispatch('setStatusLoading')
        apiUsers
            .userListRequest(context.getters.getUsersQuery)
            .then((response) => {
                context.commit('setUsers', response.data.data)
                context.commit('setCurrentUsersPage', response.data.current_page)
                context.commit('setLastUsersPage', response.data.last_page)
                context.dispatch('setStatusLoaded')
            })
            .catch(error => console.log(error))
    },
    setUsersSearchQuery: ({commit}, newValue) => {
        commit('updateUsersQuerySearch', newValue)
    },
    setUsersCurrentPageToDefault: ({commit}) => {
        commit('setCurrentUsersPage', 1)
    }
}

export default {
    state,
    getters,
    actions,
    mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/users.js